import logo from './logo.svg';
import './App.css';
import react from 'react';
import Weatherapp from './components/Weatherapp';

function App() {
  return (
    <Weatherapp/>
  );
}

export default App;

